import React from 'react';
import styled from '@emotion/styled';
import { Button } from '@vimily/bonjoro-ui-components';

const ActionContainer = styled.div`
  text-align: right;
  margin-right: 40px;
  button {
    width: 120px;
    height: 40px;
    margin-left: 15px;
  }
`;

interface StockMediaActionProps {
  onRequestClose?: () => void;
  saveMedia: () => void;
}

export default function StockMediaAction({
  saveMedia,
  onRequestClose,
}: StockMediaActionProps) {
  return (
    <ActionContainer>
      <Button variant='info' onClick={onRequestClose}>
        Cancel
      </Button>
      <Button variant='default' onClick={saveMedia}>
        Done
      </Button>
    </ActionContainer>
  );
}
